var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=xl, Color=Warning, Theme=Light circle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FEF0C7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M27.9999 23.3332V27.9999M27.9999 32.6666H28.0116M26.0049 17.3366L16.1232 33.8332C15.9195 34.1861 15.8117 34.5861 15.8106 34.9935C15.8094 35.4009 15.915 35.8016 16.1167 36.1555C16.3185 36.5095 16.6094 36.8045 16.9606 37.0111C17.3117 37.2177 17.7108 37.3288 18.1182 37.3332H37.8816C38.289 37.3288 38.6881 37.2177 39.0392 37.0111C39.3904 36.8045 39.6813 36.5095 39.8831 36.1555C40.0848 35.8016 40.1904 35.4009 40.1892 34.9935C40.1881 34.5861 40.0803 34.1861 39.8766 33.8332L29.9949 17.3366C29.7869 16.9937 29.4941 16.7102 29.1446 16.5135C28.7952 16.3167 28.4009 16.2134 27.9999 16.2134C27.5989 16.2134 27.2046 16.3167 26.8552 16.5135C26.5057 16.7102 26.2129 16.9937 26.0049 17.3366Z",
    stroke: "#DC6803",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSimple);
export default __webpack_public_path__ + "static/media/warning-simple.bb939ee8d5cab116ef2bdf7c1dfcec84.svg";
export { ForwardRef as ReactComponent };